/* eslint-disable */


/**
 * Create styles for `<AddressSearch />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<AddressSearch />` styles
 */
const addressSearchStyles = ({ theme }) => ({
  paperClasses: {
    height: `80%`,
    width: 500,
  },
  searchSelections: {
    paddingLeft: theme.spacing(1) * 2,
    paddingRight: theme.spacing(1),
  },
});

export default addressSearchStyles;
